import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Navigation.css";
import bklogo from "../../../images/bk-hossain-logo.png";

const Navigation = () => {
  return (
    <>
      <Navbar
        className="nav-bg"
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        sticky="top"
      >
        <Container>
          <Navbar.Brand className="logo" as={Link} to="/">
            <img src={bklogo} alt="" />
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav.Link
              style={{ color: "white" }}
              className="navlink navlink-home"
              as={HashLink}
              to="/home#home"
            >
              Home
            </Nav.Link>
            <Nav.Link className="navlink" as={HashLink} to="/home#about">
              About
            </Nav.Link>
            <Nav.Link
              className="navlink bk-button"
              as={HashLink}
              to="/home#projects"
            >
              Projects
            </Nav.Link>
            <Nav.Link className="navlink" as={Link} to="/blog">
              Blog
            </Nav.Link>

            {/* <Navbar.Text>
              Signed in as: <a href="#login">Mark Otto</a>
            </Navbar.Text> */}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navigation;
